import axios from 'axios'
import store from '@/store'
import router from "../router";
import { Message } from 'element-ui'
import { getToken, hasToken, isTokenExpired } from '@/utils/auth'
import { VUE_APP_API_URL } from '@utils/index'
const service = axios.create({
	baseURL: VUE_APP_API_URL,
	timeout: 5000
})
const whiteList = ['/a/authc', '/authredirect', '/api/refresh/token'] //白名单

/**
 * http request 请求拦截器，有token值则配置上token值
 */
service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			// 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
			// 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
			config.headers['Authorization'] = 'Bearer ' + getToken()

			if (whiteList.indexOf(config.url) === -1 && isTokenExpired()) {
				//判断token是否将要过期
				store.dispatch('user/refreshToken')
			}
		}
		return config
	},
	err => {
		console.log(err) // for debug
		return Promise.reject(err)
	}
)
/**
 * http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
 */
service.interceptors.response.use(
	response => {
		if (response.data.code !== 200) {
			switch (response.data.code) {
				case 400:
					Message.error('对不起，您的请求的参数不正确，换个姿势试试！！')
					break
				case 401:
					if(hasToken()){
						Message.error('对不起，您的会话已经过期，请重新登录！')
					}
					store.dispatch('user/clearToken').then(() => {
						router.replace('/login')
					})
					break;
				case 404:
					Message.error('对不起，您的请求被外星人抓走了，快去呼叫迪迦奥特曼！')
					break
				case 500:
					Message.error(response.data.message || '对不起，服务器程序出错了！')
					break
				case 504:
					Message.error(response.data.message || '对不起，服务器程序出错了！')
					break
				default:
					Message.error(response.data.message)
					break
			}
			return Promise.reject(response.data);
			// return new Promise(() => {}) 						// pending的promise，中止promise链
		} else {
			return response
		}
	},
	error => {
		if (error.response) {
			Message.error('请求出错了，请查看日志！')
			return Promise.reject(error)
		}
	}
)


export default service
